import { Directive, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";

@Directive({
    selector: '[drawerContent]'
})
export class DrawerContentDirective implements OnInit {
    public render: boolean = false;

    constructor(
        public templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef) { }

    ngOnInit() {
        this.viewContainer.clear();
    }

    show(context?: any) {
        this.render = true;
        this.viewContainer.createEmbeddedView(this.templateRef, context);
    }

    hide() {
        this.render = false;
        this.viewContainer.clear();
    }
}